//import React, { useState, useEffect } from "react";

import React, { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  StandaloneSearchBox,
  useJsApiLoader,
} from "@react-google-maps/api";

import { useNavigate } from "react-router-dom";

//const navigate = useNavigate();
const libraries = ["places"]; // for search box
const mapContainerStyle = { width: "100%", height: "350px" };

// const center = { lat: 6.5244, lng: 3.3792 }; // Lagos default

async function getAddressFromCoordinates(lat, lng) {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyAOzMSJWoysrQTZB9dRjrBhiFiqMEqMiHw`
    );

    const data = await response.json();

    if (data.status === "OK") {
      return data.results[0].formatted_address;
    } else {
      return "Address not found";
    }
  } catch (err) {
    console.error("Geocoding Error:", err);
    return "Address lookup failed";
  }
}

function GoogleMapPopup({ mapPosition, setMapPosition }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAOzMSJWoysrQTZB9dRjrBhiFiqMEqMiHw",
    libraries,
  });

  const [searchBox, setSearchBox] = useState(null);
  const searchBoxRef = useRef(null);

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <div>Loading Map...</div>;

  const handlePlacesChanged = () => {
    const places = searchBox.getPlaces();
    if (places.length === 0) return;

    const place = places[0];
    const location = place.geometry.location;

    setMapPosition({ lat: location.lat(), lng: location.lng() });
  };

  return (
    <div>
      <StandaloneSearchBox
        onLoad={(ref) => setSearchBox(ref)}
        onPlacesChanged={handlePlacesChanged}
      >
        <input
          type="text"
          placeholder="Search address"
          style={{
            boxSizing: `border-box`,
            border: `1px solid transparent`,
            width: `100%`,
            height: `40px`,
            padding: `0 12px`,
            borderRadius: `4px`,
            boxShadow: `0 2px 6px rgba(0,0,0,0.3)`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`,
          }}
        />
      </StandaloneSearchBox>

      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={mapPosition}
        zoom={15}
        onClick={(e) =>
          setMapPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() })
        }
      >
        <Marker
          position={mapPosition}
          draggable
          onDragEnd={(e) =>
            setMapPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() })
          }
        />
      </GoogleMap>
    </div>
  );
}

export { GoogleMapPopup }; // NAMED EXPORT

export default function Dashboard() {
  const API_URL =
    process.env.REACT_APP_API_URL || "https://betking.waresford.com";
  const API_URLx = process.env.REACT_APP_API_URL || "http://localhost:1000";

  const navigate = useNavigate();
  //MACDON SELECTING USER DATA FROM DATABASE
  const userid = localStorage.getItem("id");
  const email = localStorage.getItem("email");
  const username = localStorage.getItem("name");

  //--MACDON SUBMITTING TO DATABASE
  const handleSubmit = async () => {
    const formData = new FormData();

    formData.append("userid", userid);
    formData.append("name", username);
    formData.append("address", signupData.address);
    formData.append("latitude", signupData.latitude);
    formData.append("longitude", signupData.longitude);
    formData.append("permit", signupData.permit);

    if (signupData.image) {
      formData.append("image", signupData.image);
    }

    const res = await fetch(`${API_URL}/register-outlet`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    console.log(data);

    alert("Outlet Registered Successfully!");
  };
  //--MACDON SUBMITTING TO DATABASE

  const [showNotice, setShowNotice] = useState(true);
  const [showRegmap, setShowRegmap] = useState(false);

  const [signupData, setSignupData] = useState({
    name: "",
    address: "",
    latitude: "",
    longitude: "",
    permit: "yes",
  });

  const [showMap, setShowMap] = useState(false);
  const [mapPosition, setMapPosition] = useState({
    lat: 6.5244,
    lng: 3.3792,
  });

  //CSS STYLING STARTS HERE
  const backdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const formStyle = {
    background: "white",
    padding: 36,
    borderRadius: 12,
    width: 480,
    maxWidth: "90%",
    position: "relative",
    boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: 12,
    right: 12,
    fontSize: 22,
    lineHeight: 1,
    cursor: "pointer",
    border: "none",
    background: "transparent",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    marginBottom: 12,
    borderRadius: 8,
    border: "1px solid #ddd",
    boxSizing: "border-box",
    fontSize: 14,
  };

  const primaryBtn = {
    width: "100%",
    padding: "12px 14px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 15,
  };

  return (
    <div>
      {/* ===== Notification Bar ===== */}
      {showNotice && (
        <div
          style={{
            width: "100%",
            background: "#2563eb",
            color: "white",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontFamily: "Inter, sans-serif",
            position: "relative",
          }}
        >
          {/* Message */}
          <span style={{ fontSize: 15, fontWeight: 500 }}>
            Map your shop location to appear on the dashboard map!
          </span>

          {/* Action + Close */}
          <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
            <button
              onClick={() => {
                setShowRegmap(true);
                //setShowLogin(false);
              }}
              style={{
                background: "white",
                color: "#2563eb",
                padding: "8px 14px",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Map Now
            </button>

            <button
              onClick={() => navigate("/outlets")}
              style={{
                padding: 12,
                margin: "0 15px 15px 15px",
                background: "green",
                color: "white",
                border: "none",
                borderRadius: 8,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              View Outlets
            </button>

            <span
              onClick={() => setShowNotice(false)}
              style={{
                fontSize: 22,
                cursor: "pointer",
                lineHeight: 1,
                fontWeight: 600,
              }}
            >
              ×
            </span>
          </div>
        </div>
      )}
      {/* ===== Dashboard Content ===== */}
      <div style={{ padding: 30 }}>
        <h1>Dashboard</h1>
        <p>
          Welcome {username} {userid} to your dashboard.
        </p>
      </div>

      {/* Regmap Modal */}
      {showRegmap && (
        <div style={backdropStyle} onClick={() => setShowRegmap(false)}>
          <div style={formStyle} onClick={(e) => e.stopPropagation()}>
            <button
              style={closeBtnStyle}
              aria-label="Close signup"
              onClick={() => setShowRegmap(false)}
            >
              ×
            </button>

            <h2 style={{ margin: "0 0 18px", fontSize: 22 }}>Map Outlet Now</h2>

            {/* Name */}
            <input
              style={inputStyle}
              placeholder="Name"
              value={username}
              onChange={(e) =>
                setSignupData({ ...signupData, name: e.target.value })
              }
            />

            {/* Address + load button perfectly inside input */}
            <div style={{ position: "relative", width: "100%" }}>
              <input
                style={{ ...inputStyle, paddingRight: 120, height: 45 }}
                placeholder="Enter Address"
                value={signupData.address}
                onChange={(e) =>
                  setSignupData({ ...signupData, address: e.target.value })
                }
              />

              {/* STEP 4 BUTTON GOES RIGHT HERE */}
              <button
                onClick={() => {
                  // Try to get current GPS location
                  navigator.geolocation.getCurrentPosition(
                    (pos) => {
                      setMapPosition({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                      });
                      setShowMap(true);
                    },
                    () => setShowMap(true) // If denied, still open map
                  );
                }}
                style={{
                  position: "absolute",
                  right: 5,
                  top: 5,
                  height: "35px",
                  width: 110,
                  background: "#007bff",
                  border: "none",
                  borderRadius: 6,
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: 13,
                }}
              >
                Load Map
              </button>
            </div>

            {/* Coordinates Label */}
            <label style={{ marginTop: 15, fontWeight: "600" }}>
              Coordinates
            </label>

            {/* Lat & Long inline */}
            <div style={{ display: "flex", gap: 10, width: "100%" }}>
              <input
                style={{ ...inputStyle, flex: 1 }}
                placeholder="Latitude"
                value={signupData.latitude}
                onChange={(e) =>
                  setSignupData({ ...signupData, latitude: e.target.value })
                }
              />

              <input
                style={{ ...inputStyle, flex: 1 }}
                placeholder="Longitude"
                value={signupData.longitude}
                onChange={(e) =>
                  setSignupData({ ...signupData, longitude: e.target.value })
                }
              />
            </div>

            {/* Image Upload with Preview Frame */}
            <label style={{ marginTop: 15, fontWeight: 600 }}>
              Select Image
            </label>

            <div
              style={{
                width: "100%",
                height: 150,
                border: "1px solid #ccc",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                marginBottom: 10,
              }}
            >
              {signupData.image ? (
                <img
                  src={URL.createObjectURL(signupData.image)}
                  alt="Preview"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <span style={{ color: "#777" }}>No image selected</span>
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setSignupData({ ...signupData, image: e.target.files[0] })
              }
            />

            <button
              style={primaryBtn}
              // onClick={() => alert("Outlet Registered on map")}
              onClick={handleSubmit}
            >
              Register Now
            </button>
          </div>
        </div>
      )}

      {/*MACDON DECLEARING ANOTHER POP FOR MAP*/}

      {showMap && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: 500,
              background: "#fff",
              borderRadius: 10,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h3
              style={{
                padding: 15,
                margin: 0,
                background: "#f5f5f5",
                borderBottom: "1px solid #ddd",
              }}
            >
              Select Location
            </h3>

            {/* MAP CONTAINER */}
            <div
              style={{
                height: 350,
                width: "100%",
                position: "relative",
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              {/* <input
                id="map-search-input"
                type="text"
                placeholder="Search location..."
                style={{
                  width: "90%",
                  margin: "10px auto",
                  padding: "10px",
                  fontSize: 16,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  display: "block",
                }}
              /> */}
              <GoogleMapPopup
                mapPosition={mapPosition}
                setMapPosition={setMapPosition}
              />
            </div>

            {/* BUTTON */}
            <button
              onClick={async () => {
                const realAddress = await getAddressFromCoordinates(
                  mapPosition.lat,
                  mapPosition.lng
                );

                setSignupData({
                  ...signupData,
                  latitude: mapPosition.lat,
                  longitude: mapPosition.lng,
                  address: realAddress,
                });

                setShowMap(false);
              }}
              style={{
                padding: 12,
                margin: 15,
                background: "#3478f6",
                color: "white",
                border: "none",
                borderRadius: 8,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              Use This Location
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
